import { render, staticRenderFns } from "./ResultDetailCourse.vue?vue&type=template&id=b01b105c&scoped=true&"
import script from "./ResultDetailCourse.vue?vue&type=script&lang=ts&"
export * from "./ResultDetailCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b105c",
  null
  
)

export default component.exports